import { Component, OnInit } from '@angular/core';

type DeviceType = 'ios' | 'android' | 'desktop';

@Component({
  selector: 'app-app-redirect',
  templateUrl: './app-redirect.component.html',
  styleUrls: ['./app-redirect.component.css']
})
export class AppRedirectComponent implements OnInit {
  deviceType: DeviceType = 'desktop';

  readonly appStoreUrl = 'https://apps.apple.com/tr/app/cardata/id1187720629';
  readonly playStoreUrl = 'https://play.google.com/store/apps/details?id=com.cardata';

  ngOnInit(): void {
    this.deviceType = this.detectDevice();
  }

  private detectDevice(): DeviceType {
    const ua = navigator.userAgent || '';
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Macintosh') !== -1 && 'ontouchend' in document);
    if (isIOS) {
      return 'ios';
    }
    if (/android/i.test(ua)) {
      return 'android';
    }
    return 'desktop';
  }

  /**
   * Tries to open the native app, falling back to the store when it isn't installed.
   * This page is the fallback target for Universal/App Links when the app is missing,
   * but the button still attempts the app first for users who do have it.
   * iOS uses the custom scheme + App Store fallback (same-domain Safari can't use
   * Universal Links).
   */
  openApp(): void {
    if (this.deviceType === 'android') {
      const fallback = encodeURIComponent(this.playStoreUrl);
      window.location.href =
        'intent://#Intent;scheme=cardata;package=com.cardata;S.browser_fallback_url=' + fallback + ';end';
    } else if (this.deviceType === 'ios') {
      const start = Date.now();
      setTimeout(() => {
        if (Date.now() - start < 2000 && !document.hidden) {
          window.location.href = this.appStoreUrl;
        }
      }, 1200);
      window.location.href = 'cardata://';
    }
  }
}
